module.exports = __webpack_public_path__ + "img/avatar_def.d69ce13c.png";